<script setup lang="ts">
import LazyImage from '~/components/LazyImage.vue';

const ImageViewer = defineAsyncComponent(() => import('./ImageViewer.vue'));
const ImageViewerMobile = defineAsyncComponent(
	() => import('./ImageViewerMobile.vue'),
);

interface ImageSliderProps {
	media: {
		src: string;
		alt: string;
		height: number;
		width: number;
	}[];
	parent: string;
	alt: string;
}

const props = defineProps<ImageSliderProps>();

const currentSlide = ref(0);
const slideTo = (val: number) => {
	currentSlide.value = val;
};

const imgIndex = ref(0);

const imageIndex = (index: number) => {
	imgIndex.value = index;
};

provide('imgIndex', imgIndex);
</script>
<template>
	<div class="gap-7xl flex flex-col">
		<Carousel
			v-model="currentSlide"
			:items-to-show="1"
			class="pdp--image-slider"
			:wrap-around="true"
			:transition="100"
		>
			<slide
				v-for="(slide, index) in props.media"
				:key="slide.src"
				class="min-h-[400px]"
				@click="imageIndex(index)"
			>
				<ImageViewerMobile
					v-if="isMobileView()"
					:media="media"
					:index="imgIndex"
				>
				</ImageViewerMobile>

				<ImageViewer v-else :media="media" :index="imgIndex"> </ImageViewer>

				<LazyImage
					class="pdp__image-slider-image image"
					:src="slide.src"
					:alt="props.alt"
					:width="isMobileView() ? 300 : 500"
					loading="lazy"
				/>
			</slide>

			<template #addons>
				<navigation />
				<pagination />
			</template>
		</Carousel>

		<Carousel
			id="thumbnails"
			ref="carousel"
			v-model="currentSlide"
			class="lg:block hidden bg-white"
			:items-to-show="4.5"
		>
			<Slide v-for="(slide, index) in props.media" :key="slide.src">
				<div
					class="pr-md image-box w-full !min-w-max !min-h-none !bg-white cursor-pointer"
					@click="slideTo(index)"
				>
					<LazyImage
						class="rounded-xs w-full"
						:class="currentSlide === index ? '!opacity-100' : 'opacity-60'"
						:src="slide.src"
						:alt="props.alt"
						width="90"
						loading="lazy"
					/>
				</div>
			</Slide>
		</Carousel>
	</div>
</template>

<style>
/* .pdp--image-slider .carousel__item {
	@apply;
}

.pdp--image-slider .carousel__slide {
	@apply;
} */

.pdp--image-slider .carousel__prev,
.pdp--image-slider .carousel__next {
	@apply bg-white rounded-full p-md mx-3xl lg:p-lg lg:mx-5xl;
}

.pdp--image-slider .carousel__pagination {
	@apply absolute mx-auto left-[16px] px-xl py-md rounded-full right-[16px]  gap-sm w-fit bottom-xl;
}

.pdp--image-slider .carousel__pagination-item {
	@apply box-border;
}

.pdp--image-slider .carousel__pagination-button {
	@apply px-md;
}

.pdp--image-slider .carousel__pagination-button::after {
	@apply bg-white rounded-2xl size-sm opacity-55;
}

.pdp--image-slider .carousel__pagination-button--active::after {
	@apply bg-black opacity-100;
}
</style>
